import { render, staticRenderFns } from "./SchoolDaysOff.vue?vue&type=template&id=6640bc67&scoped=true"
import script from "./SchoolDaysOff.vue?vue&type=script&lang=js"
export * from "./SchoolDaysOff.vue?vue&type=script&lang=js"
import style0 from "./SchoolDaysOff.vue?vue&type=style&index=0&id=6640bc67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6640bc67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VFlex,VForm,VIcon,VLayout,VProgressCircular,VTooltip})
